import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmp_420i31x/layouts/custom.vue").then(m => m.default || m))
}